import { gql } from '@apollo/client';

const CLINIC_DEVICES_FRAGMENT = gql`
  fragment ClinicDeviceFragment on Device {
    id
    deviceId
    status
    model
    firstStudyDate
    additionalStatus
    isRenewal
    lastSync {
      time
      networkMode
      isCharging
      rssi
      fwVersion
      schema
    }
    lastUsed {
      time
      study {
        id
        friendlyId
        rma
        start
        stop
        timezone
        status
        studyType
        initDuration
        reportDueDate
        studyNote
        linkedStudies {
          friendlyId
          studyType
        }
        facility {
          name
        }
        info {
          referringPhysician {
            firstName
            lastName
            username
            contact {
              phone1
              nightPhone
              fax
            }
            email
          }
          interprettingPhysician {
            id
          }
          diagnosis {
            primary
            second
            patientMedications
            physiciansNote
          }
          followOnStudy {
            duration
            studyType
          }
        }
        device {
          deviceId
        }
      }
    }
    facility {
      id
      name
      status
    }
    canRunBiotresMCT
  }
`;

export default CLINIC_DEVICES_FRAGMENT;
